export default "__VITE_ASSET__CkGm5vsv__"